import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { CustomForms } from 'src/app/components/forms/custom-forms';
import { MainComponent } from 'src/app/components/main/main.component';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';

import { SsoService } from 'src/app/services/sso/sso.service';
import { AdministradorService } from 'src/app/services/administrador/administrador.service';

import { RolModel } from 'src/app/services/sso/models/rol.model';
import { UsuarioModel } from 'src/app/services/sso/models/usuario.model';
import { TareaModel } from 'src/app/services/administrador/models/tarea.model';

import { EditTareaComponent } from '../edit-tarea/edit-tarea.component';

@Component({
  selector: 'app-listado-tareas',
  templateUrl: './listado-tareas.component.html',
  styleUrls: ['./listado-tareas.component.css']
})
export class ListadoTareasComponent extends CustomForms implements OnInit {
  @ViewChild('windowJob') windowJob: jqxWindowComponent;
  @ViewChild('gridJobs') gridJobs: jqxGridComponent;
  @ViewChild('formJob', { read: ViewContainerRef }) editTareaComponent;

  public static _this: ListadoTareasComponent;
  private componentRef = null;
  environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  private jobsList: TareaModel[] = [];

  private rowIndex = -1;
  jobSelect: TareaModel;
  formJob: any;

  usuario: UsuarioModel;
  rol: RolModel;

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  constructor(
    private administradorService: AdministradorService,
    private ssoService: SsoService
  ) {
    super();
    ListadoTareasComponent._this = this;
  }

  init(componentRef: any){
    this.usuario = this.ssoService.getTicket().Usuario;
    this.rol = this.ssoService.getTicket().Rol;
    this.componentRef = componentRef;
  }

  ngOnInit(): void {
    this.initGrid();
  }

  async ngAfterViewInit(){
    this.addCustomForm(this.windowJob);
    this.windowJob.setTitle(this.translate('Tareas'));

    await this.getJobs();
  }

  onExpand(){
    this.gridJobs.updatebounddata();

    setTimeout(() => {
      this.gridJobs.attrColumns.forEach((column: any) => {
        try{
          this.gridJobs.autoresizecolumn(column.datafield, column.columntype);
        }catch(e){
        }
      })
    }, 500);
  }

  onClose(){
    if(this.componentRef){
      this.componentRef.destroy();
    }
  }

  async getJobs(){
    try{
      this.jobsList = await this.administradorService.getTareas();
    }catch(e){
      this.jobsList = [];
    }

    this.sourceJobs.localdata = this.jobsList;
    this.adapterJobs = new jqx.dataAdapter(this.sourceJobs);

    setTimeout(() => {
      this.gridJobs.attrColumns.forEach((column: any) => {
        try{
          this.gridJobs.autoresizecolumn(column.datafield, column.columntype);
        }catch(e){
        }
      })
    }, 500);
  }

  /* GRID JOBS */
  /*
    Comprueba si la tarea esta activada o no
    y marcar el check en el listado
  */
  renderCheckColumn = (row: number, columnfield: string, value: string | number, defaulthtml: string, columnproperties: any, rowdata: any): string => {
    if (value == 1 || value) {
      return '<div class="jqx-grid-cell-left-align" style="margin-top: 4px;">Si</div>';
    }
    else {
      return '<div class="jqx-grid-cell-left-align" style="margin-top: 4px;">No</div>';
    }
  };


  public columnsJobs;

  public sourceJobs;
  public adapterJobs;

  initGrid() {
    this.columnsJobs = [
      { text: 'id', columntype: 'textbox', datafield: 'id', width: 1, hidden: true },
      { text: this.translate('Nombre'), columntype: 'textbox', datafield: 'nombre', width: 'auto' },
      { text: 'Trigger', columntype: 'textbox', datafield: 'nombreTrigger', width: 'auto' },
      { text: this.translate('Grupo'), columntype: 'textbox', datafield: 'grupo', width: 'auto' },
      { text: this.translate('Segundos'), columntype: 'textbox', datafield: 'segundos', width: 'auto' },
      { text: this.translate('Expresion_cron'), columntype: 'textbox', datafield: 'cronExpresion', with: 'auto' },
      { text: this.translate('Activa'),  columntype: 'checkbox', datafield: 'activado', width: 'auto' }
    ]

    this.sourceJobs = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'int', map: 'id' },
        { name: 'nombre', type: 'string', map: 'nombre' },
        { name: 'nombreTrigger', type: 'string', map: 'nombreTrigger' },
        { name: 'grupo', type: 'string', map: 'grupo' },
        { name: 'segundos', type: 'int', map: 'segundos' },
        { name: 'cronExpresion', type: 'string', map: 'cronExpresion' },
        { name: 'activado', type: 'boolean', map: 'activado' }
      ],
      localdata: this.jobsList,
    }
  }

  /* Acciones del grid */
  onRowClick(event: any) {
    if (this.rowIndex != event.args.rowindex) {
      this.rowIndex = event.args.rowindex;
      this.jobSelect = this.jobsList[event.args.rowindex];
      this.gridJobs.selectrow(this.rowIndex);
    }else if(this.rowIndex === event.args.rowindex) {
      this.gridJobs.unselectrow(this.rowIndex);
      this.rowIndex = null;
      this.jobSelect = null;
    }
  }

  onRowdoubleclick(event: any) {
    this.rowIndex = event.args.rowindex;
    this.jobSelect = this.jobsList[event.args.rowindex];
    this.gridJobs.selectrow(this.rowIndex);

    this.onEditarJob();
  }

  onRowSelect(event: any) {
    this.rowIndex = event.args.rowindex;
    this.jobSelect = this.jobsList[event.args.rowindex];

    if(this.gridJobs.getselectedrowindexes().length > 1){
      this.gridJobs.clearselection();
      this.gridJobs.selectrow(event.args.rowindex);
    }
  }

  onRowUnselect(event: any){
    this.rowIndex = null;
    this.jobSelect = null;
  }

  onEditarJob(){
    if (this.jobSelect) {
      this.windowJob.collapse();

      this.formJob = this.editTareaComponent.createComponent(EditTareaComponent);
      this.formJob.instance.init(this.formJob, this.jobSelect);
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
    }
  }
}
